module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-03-en.c3991d0b983f543d656713fc3abce65e.png";